import { render, staticRenderFns } from "./IconHomework.vue?vue&type=template&id=838cf48a"
import script from "./IconHomework.vue?vue&type=script&lang=ts"
export * from "./IconHomework.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports